import React from 'react';

import './styles.less';

export const VideoPlayerOverlay = ( props ) => {
    return (
        <div className="video-player-overlay">
            <div className="video-player-overlay-background" />
            <div className="video-player-content">
                { props.children }
            </div>
        </div>
    );
};
